(function() {
  function filterGallery(montura) {
    if (!montura) return;
    document.querySelectorAll('.media-gallery__grid li').forEach(function(li) {
      var img = li.querySelector('img');
      if (!img) return;
      var alt = (img.getAttribute('alt') || '').trim();
      li.style.display = (alt === '' || alt === montura) ? '' : 'none';
    });
  }

  function getMontura() {
    var input = document.querySelector('input[name*="Color de Montura"]:checked');
    return input ? input.value : null;
  }

  // Al cargar
  document.addEventListener('DOMContentLoaded', function() {
    filterGallery(getMontura());
  });

  // Observar cuando Horizon reemplaza la galería
  var observer = new MutationObserver(function() {
    var montura = getMontura();
    if (montura) filterGallery(montura);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributeFilter: ['src']
  });

  // También al cambiar variante
  document.addEventListener('change', function(e) {
    if (e.target.name && e.target.name.includes('Color de Montura')) {
      setTimeout(function() { filterGallery(e.target.value); }, 100);
      setTimeout(function() { filterGallery(e.target.value); }, 500);
    }
  }, true);
})();